import React from "react";
import downloadApp from "../../assets/images/download-app.png";
import appStoreBadge from "../../assets/images/appleBtn.png";
import playStoreBadge from "../../assets/images/googleBtn.png";

export default function AppDownloadSection() {
  return (
    <section id="download" className="hl-download">
      <div className="hl-download__card">
        <div className="hl-download__phones">
          <img src={downloadApp} alt="Padel Kingdom app screens" />
        </div>

        <div className="hl-download__copy">
          <h2>Download The App For FREE!</h2>
          <p>
            Book your recovery sessions faster, manage your membership and
            track your progress — all from your phone.
          </p>

          <div className="hl-download__badges">
            <a href="#download" aria-label="Download on the App Store">
              <img src={appStoreBadge} alt="Download on the App Store" />
            </a>
            <a href="#download" aria-label="Get it on Google Play">
              <img src={playStoreBadge} alt="Get it on Google Play" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
